module.exports = __webpack_public_path__ + "static/media/logo-white.7175ca2d.webp";